import React, { useEffect, useState } from "react"
import { Card, CardBody, Modal, ModalBody, ModalHeader } from "reactstrap"
import { useClientContext } from "../ClientContextBox"
import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import { app_url } from "app_config"
import CustomEditor from "components/Common/CustomEditor"
import moment from "moment"
import { setUpdatedData } from "helpers/data_setters"
import { deleteNow } from "helpers/delete_function"

const ClientNotes = ({ client_id, type, heading }) => {
  const { isReadOnly, servicesCalculation } = useClientContext()

  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [note_id, setNoteId] = useState(null)
  const [note, setNote] = useState("")
  const [notes, setNotes] = useState([])
  const [date, setDate] = useState("")
  const [file, setFile] = useState("")
  const [service, setService] = useState("")
  const [fileUrl, setFileUrl] = useState("")

  useEffect(() => {
    (async () => {
      try {
        setLoading(true)
        const postData = { clientId: client_id, typeId: type }
        const response = await axiosbaseurl.post(
          `/client-note/get-all-notes`,
          postData
        )
        if (response.data.success) {
          setNotes(response.data.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  useEffect(() => {
    if (!show) {
      setNoteId(null)
      setNote("")
      setDate("")
      setFileUrl("")
      setService("")
      setFile(null)
    }
  }, [show])

  const handleSubmit = async e => {
    e.preventDefault()

    try {
      if (note && note !== "<p><br></p>" && !isReadOnly) {
        setLoading(true)
        const formData = new FormData()
        formData.append("typeId", type)
        formData.append("noteDate", date)
        formData.append("noteDescription", note)
        formData.append("uploadedNoteDocument", file)
        // if (type === 2)
        //   formData.append("serviceId", service)

        formData.append("clientId", client_id)

        let response
        // edit note
        if (note_id)
          response = await axiosbaseurl.put(`/client-note/${note_id}`, formData)
        else response = await axiosbaseurl.post(`/client-note`, formData)

        if (response.data.success) {
          setNote("")
          setDate("")
          setFile(null)
          setShow(false)
          setNotes(prev =>
            setUpdatedData(prev, response.data.data, note_id ? "edit" : "add")
          )
        }
      } else {
        swal("", "Note Description is required", "warning")
      }
    } catch (error) {
      console.log(error)
      swal(
        "",
        error.response.data.message || error.message || "Something went Wrong",
        "error"
      )
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async id => {
    try {
      const postData = { typeId: type }
      const response = await axiosbaseurl.delete(`/client-note/${id}`, postData)
      if (response.data.success)
        setNotes(prev => setUpdatedData(prev, response.data.data, "delete"))
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  return (
    <>
      <Card style={{ minHeight: "70vh" }}>
        <CardBody>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5>{heading}s</h5>
              </div>
              <div>
                {!isReadOnly && (
                  <button
                    onClick={() => {
                      setDate(moment().format("YYYY-MM-DDTHH:mm"))
                      setShow(true)
                    }}
                    className="btn btn-primary bg-blue mb-3"
                  >
                    <i className="fas fa-plus me-2"></i>
                    Add {heading}
                  </button>
                )}
              </div>
            </div>
            <div className="table-responsive">
              <table className="notes-table table">
                <tbody>
                  {notes
                    ?.sort((a, b) => b.id - a.id)
                    .map((item, i) => {
                      const docUrl = `${process.env.REACT_APP_IMAGE_PATH}/${item.uploadedNoteDocument}`
                      return (
                        <>
                          <tr>
                            <td>
                              <div>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.noteDescription,
                                  }}
                                />

                                <h6 className="mb-0">
                                  {/* <span className="pe-4 d-block mb-3 fw-semibold " >
                                    Service:  {item.serviceDetails?.serviceName || ""}
                                  </span> */}
                                  <span className="pe-4">
                                    <i className="fas fa-user me-2"></i>
                                    By{" "}
                                    {item?.employee
                                      ? `${item?.employee?.name || ""} ${item?.employee?.lastName || ""
                                      }`
                                      : "Super Admin"}
                                  </span>
                                  <span>
                                    <i className="fas fa-calendar me-2"></i>
                                    {moment(item.noteDate)
                                      .utc()
                                      .format("DD-MM-YYYY | hh:mm A")}
                                  </span>
                                </h6>
                              </div>
                            </td>

                            <td>
                              <div className="d-flex justify-content-end  pe-2">
                                {item.uploadedNoteDocument && (
                                  <a
                                    href={docUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-sm btn-dark me-2"
                                  >
                                    <i className="fas fa-download"></i>
                                  </a>
                                )}

                                {!isReadOnly && (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => {
                                        setNoteId(item.id)
                                        setNote(item.noteDescription)
                                        setService(item.serviceId)
                                        setDate(
                                          moment(item.noteDate)
                                            .utc()
                                            .format("YYYY-MM-DDTHH:mm")
                                        )
                                        item.uploadedNoteDocument &&
                                          setFileUrl(docUrl)
                                        setShow(true)
                                      }}
                                    >
                                      <i className="fas fa-pen"></i>
                                    </button>

                                    <button
                                      className="btn btn-sm btn-danger ms-2"
                                      onClick={() =>
                                        deleteNow(() => handleDelete(item.id))
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        </>
                      )
                    })}
                  {notes?.length === 0 && (
                    <div className="alert alert-success ps-4">
                      No Note Found !!
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </CardBody>
      </Card>

      <Modal
        size="lg"
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <ModalHeader className="w-100 bg-primary">
              <div className="d-flex align-items-center justify-content-between w-100">
                <h4 className="mb-0 text-white">
                  {" "}
                  {note_id ? "Edit" : "Add"} {heading}
                </h4>
                <div>
                  <LoadingButton
                    loading={loading}
                    btnText="Submit"
                    btn={"light"}
                  />
                  <button
                    type="button"
                    className="btn btn-danger ms-3"
                    onClick={() => setShow(!show)}
                  >
                    <i className="fa fa-times me-2"></i> Close
                  </button>
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="px-3 ">
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label>
                      Date <span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      value={date}
                      onChange={e => setDate(e.target.value)}
                      className="form-control input-field"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="d-flex justify-content-between">
                      <label>Upload Document </label>
                      <div>
                        {fileUrl && (
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="fw-semibold"
                          >
                            View Document
                          </a>
                        )}
                      </div>
                    </div>

                    <input
                      type="file"
                      placeholder="Enter Template Name"
                      // value={file}
                      onChange={e => setFile(e.target.files[0])}
                      className="form-control input-field"
                    // required={fileUrl ? false : true}
                    />
                  </div>
                </div>
                {/* for work notes */}
                {/* {
                  type === 2 ?
                    <div className="col-md-12 mb-4">

                      <label>
                        Service <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select input-field"
                        value={service}
                        onChange={e => setService(e.target.value)}
                      >
                        <option value="">Select Service</option>
                        {servicesCalculation
                          ?.filter((serv) => serv.isChecked)
                          ?.sort((a, b) => a.name.localeCompare(b.name))
                          ?.map(option => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                      </select>
                    </div> : null
                } */}

                <div className="col-md-12 mb-4">
                  <label>
                    Note <span className="text-danger">*</span>
                  </label>
                  <CustomEditor
                    content={note}
                    setContent={setNote}
                    height={300}
                  />
                </div>
              </div>
            </ModalBody>
          </form>
        </div>
      </Modal>
    </>
  )
}

export default ClientNotes
